import { Typography } from "@circle-react-uikit/Typography";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { useCircleV4 } from "@circle-react/hooks/useCircleV4";
import { Banner } from "@circleco/compass/components/Banner";

import { t } from "@/i18n-js/instance";

import { WarningWrapper } from "./WarningWrapper";

export const SubscriptionOnGracePeriod = () => {
  const { currentCommunity } = usePunditUserContext();
  const { isCircleV4 } = useCircleV4();

  if (!currentCommunity?.subscription?.ends_at) {
    return null;
  }

  if (isCircleV4) {
    return (
      <Banner
        variant="warning"
        icon="triangle-exclamation"
        iconColor="warning"
        title={t("subscription.subscription_on_grace_period.title")}
        description={t(
          "subscription.subscription_on_grace_period.description",
          {
            date: dateStringToTimeAgo(currentCommunity?.subscription?.ends_at),
          },
        )}
      />
    );
  }

  return (
    <WarningWrapper>
      <Typography.LabelLg weight="semibold">
        {t("subscription.subscription_on_grace_period.title")}
      </Typography.LabelLg>
      <Typography.BodyMd color="text-default">
        {t("subscription.subscription_on_grace_period.description", {
          date: dateStringToTimeAgo(currentCommunity?.subscription?.ends_at),
        })}
      </Typography.BodyMd>
    </WarningWrapper>
  );
};
